import { useQuery } from "@tanstack/react-query";
import { apiGet } from "./client";

/** Same tables risk-pricing-engine's own lib/api/reference.ts reads
 *  (athena_bfsi_rbp.office / annualized_loss_calibiration), scoped under
 *  /annualized-loss since this app has no other reference-list endpoints. */
export interface Office {
  officeNumber: number;
  officeName: string;
}

export function useAnnualizedLossOffices() {
  return useQuery({
    queryKey: ["annualized-loss", "offices"] as const,
    queryFn: () => apiGet<Office[]>("/annualized-loss/offices"),
    staleTime: 5 * 60_000,
  });
}

export function useAnnualizedLossRatings() {
  return useQuery({
    queryKey: ["annualized-loss", "ratings"] as const,
    queryFn: () => apiGet<string[]>("/annualized-loss/ratings"),
    staleTime: 5 * 60_000,
  });
}
